
import { useRemarkSync } from 'react-remark';
import styled from 'styled-components';
import devices from '@/utilities/devices';

const TextContainer = styled.p<{
	color?: string;
	textAlign?: 'center' | 'left' | 'right' | 'justify';
}>`
	color: ${({ color, theme }: any) => color ? theme.color[color] : theme.color.black};
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	margin: 1.7rem 0;
	text-align: ${({ textAlign }) => textAlign};
	a {
		color: ${({ theme }) => theme.color.prune};
	}

	@media screen and (${devices.mobile}) {
		padding: 1.3rem 0;
		margin: 0;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		padding: 1.5rem 3rem;
		margin: 0;
	}
`;

interface TextProps {
	readonly children: any;
	readonly color?: string;
	readonly textAlign?: 'center' | 'left' | 'right' | 'justify';
}

const Text = ({ children, color, textAlign }: TextProps) => {

	const markdownContent = useRemarkSync(children, {
		rehypeReactOptions: {
			components: {
				p: (props: any) => (
					<TextContainer color={color} textAlign={textAlign} {...props}/>
				),
			},
		},
	});

	return markdownContent;
};

export default Text;
